import { render, staticRenderFns } from "./theme-toggle.vue?vue&type=template&id=6632eede"
import script from "./theme-toggle.vue?vue&type=script&lang=js"
export * from "./theme-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports